import { BsSearch } from 'react-icons/bs';

const AcademiaSearchInput = ({
  searchText,
  setSearchText,
  inputLabel,
  removeBorder,
}: {
  searchText: string;
  setSearchText: React.Dispatch<React.SetStateAction<string>>;
  inputLabel?: string;
  removeBorder?: boolean;
}) => {
  // rendering custom search input for tables declared here
  return (
    <div
      className={`flex items-center gap-2 px-3 py-2 rounded-md font-semibold ${
        !removeBorder && 'border-2 border-legal-dark-blue text-legal-dark-blue'
      }`}
    >
      <BsSearch className='min-h-5 min-w-5' />
      <input
        type='text'
        className='w-full outline-none'
        placeholder={inputLabel ? inputLabel : 'Search Table...'}
        value={searchText}
        onChange={(e) => setSearchText(e.target.value)}
      />
    </div>
  );
};

export default AcademiaSearchInput;
